module.exports = __webpack_public_path__ + "band_4.f2a3182f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_4.png
// module id = qsTh
// module chunks = 0